'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'megaphone';
var width = 576;
var height = 512;
var aliases = [128227];
var unicode = 'f675';
var svgPathData = 'M16 160C7.164 160 0 167.2 0 176v160C0 344.8 7.164 352 16 352S32 344.8 32 336v-160C32 167.2 24.84 160 16 160zM560 32C551.2 32 544 39.16 544 48v11.38L64 172.2v32.88l480-112.9v327.5L64 306.9v32.85l98.63 23.12C161 369.8 160 376.8 160 384c0 53 43 96 96 96c45.13 0 82.5-31.25 92.63-73.25L544 452.6V464c0 8.836 7.164 16 16 16s16-7.164 16-16v-416C576 39.16 568.8 32 560 32zM256 448c-35.25 0-64-28.75-64-64c0-4.75 .75-9.25 1.75-13.75l124.1 29.25C310.9 427.3 285.9 448 256 448z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faMegaphone = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;


//////////////////
// WEBPACK FOOTER
// ./~/@fortawesome/pro-light-svg-icons/faMegaphone.js
// module id = eBET
// module chunks = 0